var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.84886 11.2955C1.78611 11.1055 1.78605 10.8998 1.84869 10.7098C3.10979 6.88391 6.68595 4.125 10.9006 4.125C15.1134 4.125 18.6882 6.88135 19.9508 10.7045C20.0136 10.8945 20.0136 11.1002 19.951 11.2902C18.6899 15.1161 15.1137 17.875 10.899 17.875C6.68632 17.875 3.11153 15.1187 1.84886 11.2955Z",
    stroke: "#120A8F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6249 11C13.6249 12.5188 12.4049 13.75 10.8999 13.75C9.39493 13.75 8.1749 12.5188 8.1749 11C8.1749 9.48122 9.39493 8.25 10.8999 8.25C12.4049 8.25 13.6249 9.48122 13.6249 11Z",
    stroke: "#120A8F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/View.47fbebfbb54b7d90e66ec0c5c20cc8b8.svg";
export { ForwardRef as ReactComponent };